import React, {Component} from "react";
import AsyncCreatableSelect from "react-select/async-creatable/dist/react-select.esm";
import RemotingService from "../../../../services/remoting-service/RemotingService";

const MIN_SEARCH_LENGTH = 2;

// Matches the "Performing Clinician" selectStyles in ReferralCliniciansTab.js
const selectStyles = {
    control: (base) => ({ ...base, minHeight: '30px', height: '30px', fontSize: '14px', padding: '0px' }),
    valueContainer: (base) => ({ ...base, height: '30px', padding: '0 8px' }),
    input: (base) => ({ ...base, margin: '0px', padding: '0px' }),
    indicatorsContainer: (base) => ({ ...base, height: '30px' }),
    option: (base) => ({ ...base, fontSize: '13px', padding: '6px 8px' }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

export default class ExternalClinicSelect extends Component {

    loadOptions = (inputValue, callback) => {
        if (!inputValue || inputValue.length < MIN_SEARCH_LENGTH) {
            return callback([]);
        }
        const params = {search: inputValue};
        if (this.props.type) {
            params.type = this.props.type;
        }
        RemotingService.getRemoteCall('api/insurance/coordinator/v2/referral/clinic',
            params, (result) => {
                const clinics = Array.isArray(result) ? result : (result?.items || []);
                callback(clinics.map(clinic => ({
                    value: clinic,
                    label: this.props.field === 'clinicId'
                        ? `${clinic.clinicId} - ${clinic.name}`
                        : `${clinic.name} - ${clinic.clinicId}`,
                })));
            });
    }

    noOptionsMessage = ({inputValue}) =>
        (!inputValue || inputValue.length < MIN_SEARCH_LENGTH)
            ? `Type ${MIN_SEARCH_LENGTH} characters`
            : "No options";

    handleChange = (option) => {
        const {onTextChange, onClinicSelect} = this.props;
        if (!option || option.__isNew__) {
            onTextChange && onTextChange(option ? option.value : '');
        } else {
            onClinicSelect && onClinicSelect(option.value);
        }
    }

    render() {
        const {value, placeholder, disabled, menuPortalTarget, menuPosition, styles} = this.props;
        return (
            <AsyncCreatableSelect
                styles={{...selectStyles, ...(styles || {})}}
                placeholder={placeholder}
                isDisabled={disabled}
                menuPlacement="auto"
                value={value ? {value, label: value} : null}
                loadOptions={this.loadOptions}
                noOptionsMessage={this.noOptionsMessage}
                onChange={this.handleChange}
                formatCreateLabel={(input) => `Create "${input}"`}
                menuPortalTarget={menuPortalTarget}
                menuPosition={menuPosition}
            />
        );
    }
}
